import { useState, useEffect } from "react";
import { useLazyQuery, gql } from "@apollo/client";
import { useSelector } from "react-redux";
import { GET_COUNTRY_SPECIALTY_LIST } from "./query";
import { Loader, SectionTitle } from "../shared";
import { Link } from "react-router-dom";
import { COUNTRY_LIST } from "../../utils";

const CountrySpecialtyList = () => {
    const { userType, country } = useSelector((state) => state.users.currentUser);

    const [countrySpecialty, setCountrySpecialty] = useState([]);

    const [getSpeciality, { loading, data }] = useLazyQuery(gql`
        ${GET_COUNTRY_SPECIALTY_LIST}
    `);

    useEffect(() => {
        let variables = {};
        if (Number(userType) === 1) {
            variables = {
                filter: {
                    country: {
                        in: [...country],
                    },
                },
            };
        }

        getSpeciality({ variables });

        if (data) {
            const specialtyList = data?.allAbbvieProGroupSpecialties?.nodes.map(
                (node) => node.country
            );

            setCountrySpecialty([...new Set(specialtyList)]);
        }
    }, [data]);

    return (
        <>
            {loading && <Loader />}
            <SectionTitle
                title="Group Specialty Country List"
                buttonUrl="/abbvie-pro/group-specialties/create"
                backUrl="/abbvie-pro"
            />
            <div className="row">
                <div className="col mt-n4">
                    <div className="accordion mt-5" id="accordionFormList">
                        <div className="card">
                            <div className="card-header" id="headingOne">
                                <h1 className="mb-0">
                                    <button
                                        style={{ textDecoration: "none" }}
                                        className="btn btn-link btn-block text-left font-weight-bold"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        Country List
                                    </button>
                                </h1>
                            </div>
                        </div>

                        {countrySpecialty.length > 0 &&
                            countrySpecialty.map((item) => (
                                <div key={item} className="card">
                                    <div className="card-header collapse_button" id={item + item}>
                                        <h5 className="mb-0">
                                            <Link
                                                key={item}
                                                className="btn btn-link btn-block text-left"
                                                style={{
                                                    textDecoration: "none",
                                                    color: "black",
                                                }}
                                                to={`/abbvie-pro/group-specialties/${item}`}
                                            >
                                                {COUNTRY_LIST[item]}
                                            </Link>
                                        </h5>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CountrySpecialtyList;
